var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== null && _vm.value !== undefined)?_c('tr',{staticClass:"loggerDetails"},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.$t(("" + _vm.labelName))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.value))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }